import DescriptionList from '@anwb/poncho/components/description-list';
import styled from 'styled-components';

const StyledDescriptionList = styled(DescriptionList)`
	dt {
		flex-basis: 50%;
	}

	dd {
		flex-basis: 50% !important;
	}
`;

export default StyledDescriptionList;
